var $ = require('jquery');
var slick = require('slick-carousel');

module.exports = (function() {
	(function() {
		var $slider = $('.hcat__slider'),
			$control = $('.hcat__control'),
			$controlActive = $control.filter('.hcat__control--active');

		if($slider.length == 0) return;

		$slider.slick({
			dots: false,
			arrows: false,
			draggable: false,
			fade: true,
			initialSlide: $controlActive.length > 0 ? $controlActive.data('slideIndex') : 0
		});

		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			$control.removeClass('hcat__control--active').filter('[data-slide-index="'+nextSlide+'"]').addClass('hcat__control--active');
		});

		$control.on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			$slider.slick('slickGoTo', this.dataset.slideIndex);
		});
	})();

	(function() {
		$('.slider-items__slick').slick({
			slidesToShow: 4,
			prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-slider-prev"></i></button>',
			nextArrow: '<button type="button" class="slick-next"><i class="icon icon-slider-next"></i></button>',
			responsive:  [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				},
				{
					breakpoint: 768,
					settings: {
						prevArrow: '<button type="button" class="slick-prev" style="background: none;"><i class="icon icon-slider-prev-grey"></i></button>',
						nextArrow: '<button type="button" class="slick-next" style="background: none;"><i class="icon icon-slider-next-grey"></i></button>',
						slidesToShow: 1,
						slidesToScroll: 1
					}
				},
			]
		});
	})();

	(function() {
		$('.header__search').on('mouseenter', function() {
			$(this).addClass('header__search--open');
		}).on('mouseleave', function() {
			if( ! $(this).hasClass('header__search--focus')) {
				$(this).removeClass('header__search--open');
			}
		}).find('.hcat__search-input')
			.on('focusin', function() {
				$(this).parents('.header__search').addClass('header__search--focus');
			})
			.on('focusout', function() {
				$(this).parents('.header__search--open').removeClass('header__search--open header__search--focus');
			});
	})();

	(function() {
		$(window).on('resize', function() {
			var heightWrap = 0,
				heightInfo = 0;

			$('.hcat--catalog .hcat__item').each(function() {
				var $this = $(this),
					hWrap = $this.find('.hcat__wrap').outerHeight(),
					hInfo = $this.find('.hcat__info').outerHeight();

				if(hWrap > heightWrap) heightWrap = hWrap;

				if(hInfo > heightInfo) heightInfo = hInfo;
			}).each(function() {
				var $this = $(this);

				$this.find('.hcat__wrap').css('height', heightWrap);

				$this.find('.hcat__info').css('min-height', heightInfo);
			});
		}).trigger('resize');
	})();
})();
